let logs = [];
let enableFileLogs = false; // Enable True to download logs file
let logFilePath = "logs.txt"; // Tizen
let localFileName = "logs_local.txt"; // Local PC
let localFileContent = ""; // Buffer for local logs
let logCount = 0; // Counter for logs
const LOG_BATCH_SIZE = 10; // Download after 10 logs

export const setFileLogging = (value) => {
  enableFileLogs = Boolean(value);
};

const formatLogTime = (date = new Date()) => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");

  const hr = String(date.getHours()).padStart(2, "0");
  const min = String(date.getMinutes()).padStart(2, "0");
  const sec = String(date.getSeconds()).padStart(2, "0");
    const ms = String(date.getMilliseconds()).padStart(3, "0");


  return `${yyyy}-${mm}-${dd} - ${hr}h:${min}m:${sec}sec:${ms}ms`;
};


export const logFocusEvent = (label, data = {}) => {
 

  const entry = {
    timestamp: formatLogTime(),
    label,
    data
  };

  logs.push(entry);

   console.log("Log Event", logs);


  // Tizen write
  if (enableFileLogs) {
    writeLogToFile(entry);
     // Local PC write
  writeLogToLocalFile(entry);
  }
};

export const clearLogs = () => {
  logs = [];
  localFileContent = "";
  logCount = 0;
};

// --------------------
// Tizen write (unchanged)
const writeLogToFile = (entry) => {
  if (typeof window === "undefined" || !window.tizen) {
    console.warn("Tizen API not available; skipping TV file write.");
    return;
  }

  const logString = JSON.stringify(entry, null, 2) + "\n";

  try {
    window.tizen.filesystem.resolve("documents", function (dir) {
      dir.openFile(
        logFilePath,
        "a",
        function (file) {
          file.write(logString);
          file.close();
        },
        function (err) {
          console.error("Error opening file:", err);
        }
      );
    });
  } catch (e) {
    console.error("Tizen FS error:", e);
  }
};

// --------------------
// Local system file (browser)
const writeLogToLocalFile = (entry) => {
  // Pretty-print each log entry
  const logString = JSON.stringify(entry, null, 2) + "\n\n"; // separate entries
  localFileContent += logString;
  logCount++;

  // Only download when batch size is reached
  if (logCount >= LOG_BATCH_SIZE && localFileContent.trim() !== "") {
    triggerDownload();
    logCount = 0; // Reset counter
    localFileContent = ""; // Clear buffer
  }
};

// Trigger the actual download
const triggerDownload = () => {
  const blob = new Blob([localFileContent], { type: "text/plain" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = localFileName;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};